import toast from 'react-hot-toast';

const options = {
    style: {
        zIndex: 99999,
    },
};

export const showSuccess = (msg: string) => toast.success(msg, options);
export const showError = (msg: string) => toast.error(msg, options);
export const showWarning = (msg: string) => toast(msg, { ...options, icon: '⚠️' });
